import React from 'react';
import styles from '../../../styles/portfolio/highlighted_text.scss';


export const HighlightedText = props => {
    return (
        <span className={styles.container}>{props.text}</span>
    )
};
